import { useQuery } from '@tanstack/react-query';
import { getGateConfig, type GateConfig } from '@/data/gateConfig';

/**
 * Hook to fetch product gate configuration
 * Follows playbook pattern: React Query with aggressive caching
 */
export function useGateConfig() {
  return useQuery<GateConfig>({
    queryKey: ['gate-config'],
    queryFn: getGateConfig,
    staleTime: 10 * 60 * 1000, // 10 minutes
    gcTime: 60 * 60 * 1000, // 1 hour
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
}
